import { useCallback } from 'react'
import throttle from 'lodash/throttle';

function useThrottle(callback, delay, dependencies) {
  const d = callback
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const _callback = useCallback(throttle(d, delay), dependencies)
  return [_callback];
}

export default useThrottle;